export enum BlsErrorCode {
  BLS_0 = 'bls-0',
  BLS_2 = 'bls-2',
  BLS_3 = 'bls-3',
  BLS_4 = 'bls-4',
  BLS_5 = 'bls-5',
  BLS_6 = 'bls-6',
}
